import React from 'react'

import { Row } from '@amzn/stencil-react-components/layout'
import {
    ModalBody,
    ModalContainer,
    ModalFooter,
    ModalHeader,
} from '@amzn/stencil-react-components/modal'
import { H2 } from '@amzn/stencil-react-components/text'

export type ModalContentProps = React.PropsWithChildren<{
    titleText: string
    /** Shown after the title, e.g. a status chip. */
    titleAdornment?: React.ReactNode
    buttons?: React.ReactNode[]
    maxWidth?: string
    // dataTestId isn't passed properly to ModalContainer by Stencil so
    // it's not part of the props list
}>

// Replacement for Stencil's deprecated <ModalContent>
export const ModalContent = ({
    titleText,
    titleAdornment,
    buttons = [],
    maxWidth,
    children,
}: ModalContentProps) => (
    <ModalContainer maxWidth={maxWidth}>
        <ModalHeader
            // Prevents the title from covering the contents within ModalBody.
            isSticky={false}
        >
            {titleAdornment ? (
                <Row alignItems='center' gridGap='S200'>
                    <H2>{titleText}</H2>
                    {titleAdornment}
                </Row>
            ) : (
                <H2>{titleText}</H2>
            )}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
        <ModalFooter>{buttons}</ModalFooter>
    </ModalContainer>
)
